export enum TipoResultadoContato{
    ACORDO = "ACORDO",
    JA_PAGOU  = "JA_PAGOU",
    PROMESSA  = "PROMESSA",
    SEM_CONTATO = "SEM_CONTATO"
}

export const getResultadoContatoFormatado = (resultadoContato : TipoResultadoContato) => {
    switch(resultadoContato){
        case TipoResultadoContato.ACORDO:
            return 'Em andamento'
        case TipoResultadoContato.JA_PAGOU:
            return 'Já pagou'
        case TipoResultadoContato.PROMESSA:
            return 'Promessa'   
        case TipoResultadoContato.SEM_CONTATO:
            return 'Sem Contato'
    }

}
